<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="systemBox">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">

        <!-- 短信条数限制 -->
        <div class="audit">
          <el-form-item label="" prop="isMaxNumber">
          <span class="messageNumber-desc">短信条数</span>
            <el-select v-model="ruleForm.isMaxNumber" class="maxNumber" @change="changeMaxNumber">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-form-item prop="maxNumber" class="isMaxNumber messageNumber">
              <el-input-number v-model.number="ruleForm.maxNumber" v-if="!ruleForm.isMaxNumber" placeholder="请输入短信条数" controls-position="right" :min="1"></el-input-number>
            </el-form-item>
          </el-form-item>
        </div>

        <!-- 学生注册时若填写手机号，则做短信校验 -->
        <div class="audit">
          <div class="setState">
            <span>注册验证</span>
            <div>
              <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.registCheck"></el-switch>
              <p class="audit-desc">根据学生注册时填写的手机号或邮箱，进行短信或邮件校验</p>
            </div>
          </div>
        </div>

        <!-- 手机验证登录方式 -->
        <div class="audit">
          <div class="setState">
            <span>登录验证</span>
              <div>
                <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.loginCheck"></el-switch>
                <p class="audit-desc">根据学生注册时填写的手机号或邮箱，可以选择手机验证码或邮箱验证码方式进行登录</p>
              </div>
          </div>
        </div>

        <!-- 短信设置样式修改 -- Tabs选项卡 -->
        <div class="audit">
          <div class="setState">
            <span>审核通知</span>
            <template>
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

                <!-- 审核通过样式 -->
                <el-tab-pane label="终审通过" name="first">
                  <!-- 审核通过时发短信提醒 -->
                  <div class="first-examine">
                    <div class="pane">
                      <span class="pane-span">终审通过后给学生发短信/邮件通知</span>
                      <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.auditPassCheck"></el-switch>
                    </div>
                    <el-form-item label="" prop="auditPassCheckInfo" v-if="ruleForm.auditPassCheck == 1 ? true : false" class="is-required">
                      <el-input type="textarea" v-model="ruleForm.auditPassCheckInfo" ></el-input>
                      <span class="wordNumber">{{ruleForm.auditPassCheckInfo.length}} / {{messageNumber}}</span>
                    </el-form-item>
                    <p style="color:#9299A6;" v-if="ruleForm.auditPassCheck == 1 ? true : false">短信/邮件内容中<span style="color:#006AFF;display:inline;">{缴费截止时间}</span>的信息由系统自动读取</p>
                  </div>
                </el-tab-pane>

                <!-- 初审不通过样式 -->
                <el-tab-pane label="初审不通过" name="second">
                  <!-- 初审不通过(允许重新报名)发短信提醒 -->
                  <div class="first-examine">
                    <div class="pane">
                      <span class="pane-span">初审不通过（允许重新提交报名）发短信/邮件通知</span>
                      <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.stationAuditFailCheck"></el-switch>
                    </div>
                    <el-form-item label="" prop="stationAuditFailCheckInfo" v-if="ruleForm.stationAuditFailCheck == 1 ? true : false" class="is-required">
                      <el-input type="textarea" v-model="ruleForm.stationAuditFailCheckInfo" ></el-input>
                      <span class="wordNumber">{{ruleForm.stationAuditFailCheckInfo.length}} / {{messageNumber}}</span>
                    </el-form-item>
                    <p style="color:#9299A6;" v-if="ruleForm.stationAuditFailCheck == 1 ? true : false">短信/邮件内容中<span style="color:#006AFF;display:inline;">{审核不通过原因}</span>的信息由系统自动读取</p>
                  </div>
                  <!-- 初审不通过(不允许重新提交报名)发短信提醒 -->
                  <div class="first-examine">
                    <div class="pane">
                      <span class="pane-span">初审不通过（不允许重新提交报名）发短信/邮件通知</span>
                      <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.stationAuditRefuseCheck"></el-switch>
                    </div>
                    <el-form-item label="" prop="stationAuditRefuseCheckInfo" v-if="ruleForm.stationAuditRefuseCheck == 1 ? true : false" class="is-required">
                      <el-input type="textarea" v-model="ruleForm.stationAuditRefuseCheckInfo" ></el-input>
                      <span class="wordNumber">{{ruleForm.stationAuditRefuseCheckInfo.length}} / {{messageNumber}}</span>
                    </el-form-item>
                    <p style="color:#9299A6;" v-if="ruleForm.stationAuditRefuseCheck == 1 ? true : false">短信/邮件内容中<span style="color:#006AFF;display:inline;">{审核不通过原因}</span>的信息由系统自动读取</p>
                  </div>
                </el-tab-pane>

                <!-- 终审不通过样式 -->
                <el-tab-pane label="终审不通过" name="third">
                  <!-- 终审不通过(允许重新报名)发短信提醒 -->
                  <div class="first-examine">
                    <div class="pane">
                      <span class="pane-span">终审不通过（允许重新提交报名）发短信/邮件通知</span>
                      <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.auditFailCheck"></el-switch>
                    </div>
                    <el-form-item label="" prop="auditFailCheckInfo" v-if="ruleForm.auditFailCheck == 1 ? true : false" class="is-required">
                      <el-input type="textarea" v-model="ruleForm.auditFailCheckInfo" ></el-input>
                      <span class="wordNumber">{{ruleForm.auditFailCheckInfo.length}} / {{messageNumber}}</span>
                    </el-form-item>
                    <p style="color:#9299A6;" v-if="ruleForm.auditFailCheck == 1 ? true : false">短信/邮件内容中<span style="color:#006AFF;display:inline;">{审核不通过原因}</span>的信息由系统自动读取</p>
                  </div>
                  <!-- 终审不通过(不允许重新报名)发短信提醒 -->
                  <div class="first-examine">
                    <div class="pane">
                      <span class="pane-span">终审不通过（不允许重新提交报名）发短信/邮件通知</span>
                      <el-switch :active-value="1" :inactive-value="0" v-model="ruleForm.auditRefuseCheck"></el-switch>
                    </div>
                    <el-form-item label="" prop="auditRefuseCheckInfo" v-if="ruleForm.auditRefuseCheck == 1 ? true : false" class="is-required">
                      <el-input type="textarea" v-model="ruleForm.auditRefuseCheckInfo"></el-input>
                      <span class="wordNumber">{{ruleForm.auditRefuseCheckInfo.length}} / {{messageNumber}}</span>
                    </el-form-item>
                    <p style="color:#9299A6;" v-if="ruleForm.auditRefuseCheck == 1 ? true : false">短信/邮件内容中<span style="color:#006AFF;display:inline;">{审核不通过原因}</span>的信息由系统自动读取</p>
                  </div>
                </el-tab-pane>

              </el-tabs>
            </template>
          </div>
        </div>

      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name:"systemMessage",
  data() {
    return {
      // 输入框内样式(审核通过)
      approved : `<span style="color:red;">{审核不通过原因}<span>`,
      // 选项卡绑定数据
      activeName: 'first',
      saveMethods: "submitForm",
      backMethods: "goIndex",
      options: [
        {
          value: false,
          label: "限制",
        },
        {
          value: true,
          label: "不限制",
        },
      ],
      ruleForm: {
        // 短信条数限制
        isMaxNumber: false,
        // 短信条数限制
        maxNumber: "",
        // 短信校验
        registCheck: "",
        // 登录方式
        loginCheck: "",
        // 短信提醒(审核通过)
        auditPassCheck: "",
        auditPassCheckInfo: "",
        // 短信提醒(审核不通过--重新报名)
        auditFailCheck: "",
        auditFailCheckInfo: "",
        // 短信提醒(审核不通过--不可以重新报名)
        auditRefuseCheck: "",
        auditRefuseCheckInfo: "",
        // 初审不通过短信提醒(初审不通过--重新报名)
        stationAuditFailCheck: "",
        stationAuditFailCheckInfo: "",
        // 初审不通过短信提醒(初审不通过--不可以重新报名)
        stationAuditRefuseCheck: "",
        stationAuditRefuseCheckInfo: "",
      },
      rules: {
        isMaxNumber : [
          { required: true, message: "", trigger: "change" }
        ],
        maxNumber: [
          { required: true, message: "请输入短信条数", trigger: "blur" },
          { validator: this.isNumber, trigger:"blur" }
        ],
        auditPassCheckInfo : [
          { validator: this.auditLangth, trigger:"blur" }
        ],
        auditFailCheckInfo : [
          { validator: this.auditLangth, trigger:"blur" }
        ],
        auditRefuseCheckInfo : [
          { validator: this.auditLangth, trigger:"blur" }
        ],
        stationAuditFailCheckInfo : [
          { validator: this.auditLangth, trigger:"blur" }
        ],
        stationAuditRefuseCheckInfo : [
          { validator: this.auditLangth, trigger:"blur" }
        ]
      },
      // 短信系统配置
      configValue: "",
      // 短信签名长度
      signNameLength : "",
      // 可输入短信内容长度
      messageNumber : 68,
    };
  },
  created() {
    this.getConfigData();
  },
  mounted(){
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    // 选项卡绑定事件
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    ...mapMutations(['SAVE_PAGE_THIS']),

    goIndex() {
      window.location.reload();
    },

    /********************************
     * @this : 获取短信配置数据
     *******************************/
    getConfigData() {
      this.$api.system.getConfigMessageInfo().then((res) => {
        if(res.code == 1){
          this.configValue = res.data;
          res.data.forEach(e=>{
            // 1.短信签名
            // if(e.setName == "signName"){
            //   this.ruleForm.signName = e.setText;
            //   this.signNameLength = e.setText.length;
            //   this.messageNumber = 68 - this.signNameLength;
            // }
            // 2.短信条数限制
            if(e.setName == "maxNumber"){
              this.ruleForm.maxNumber = e.setValue;
            }
            // 3.短信校验
            if(e.setName == "registCheck"){
              this.ruleForm.registCheck = e.setValue;
            }
            // 4.手机验证登录方式
            if(e.setName == "loginCheck"){
              this.ruleForm.loginCheck = e.setValue;
            }
            // 5.报名人工审核通过时发短信提醒
            if(e.setName == "auditPassCheck"){
              this.ruleForm.auditPassCheck = e.setValue;
              this.ruleForm.auditPassCheckInfo = e.setText;
            }
            // 6.审核不通过(可以重新提交)发短信提醒
            if(e.setName == "auditFailCheck"){
              this.ruleForm.auditFailCheck = e.setValue;
              this.ruleForm.auditFailCheckInfo = e.setText;
            }
            // 7.审核不通过(不可以重新提交)发短信提醒
            if(e.setName == "auditRefuseCheck"){
              this.ruleForm.auditRefuseCheck = e.setValue;
              this.ruleForm.auditRefuseCheckInfo = e.setText
            }
            // 8.初审不通过(可以重新提交)发短信提醒
            if(e.setName == "stationAuditFailCheck"){
              this.ruleForm.stationAuditFailCheck = e.setValue;
              this.ruleForm.stationAuditFailCheckInfo = e.setText;
            }
            if(e.setName == "stationAuditRefuseCheck"){
              this.ruleForm.stationAuditRefuseCheck = e.setValue;
              this.ruleForm.stationAuditRefuseCheckInfo = e.setText
            }
          }) 
        } 
      });
    },

    /********************************
     * @this : 提交表单操作
     * @ruleForm : 表单名
     *******************************/
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.configValue.forEach((e) => {
            // 1.短信条数限制
            if(e.setName == "maxNumber"){
              e.setValue = this.ruleForm.maxNumber;
            }
            // 2.短信签名
            if(e.setName == "signName"){
              e.setText = this.ruleForm.signName;
            }
            // 3.短信校验
            if(e.setName == "registCheck"){
              e.setValue = this.ruleForm.registCheck;
            }
            // 4.手机验证登录方式
            if(e.setName == "loginCheck"){
              e.setValue = this.ruleForm.loginCheck;
            }        
            // 5.报名人工审核通过时发短信提醒
            if(e.setName == "auditPassCheck"){
              e.setValue = this.ruleForm.auditPassCheck; 
              if(this.ruleForm.auditPassCheck == 1){
                e.setValue = 1;
                e.setText = this.ruleForm.auditPassCheckInfo;
              } else {
                e.setValue = 0;
              }
            }      
            // 6.审核不通过(可以重新提交)发短信提醒
            if(e.setName == "auditFailCheck"){
              e.setValue = this.ruleForm.auditFailCheck;
              if(this.ruleForm.auditFailCheck == 1){
                e.setValue = 1;
                e.setText = this.ruleForm.auditFailCheckInfo;
              } else {
                e.setValue = 0;
              }
            } 
            // 7.审核不通过(不可以重新提交)发短信提醒
            if(e.setName == "auditRefuseCheck"){
              e.setValue = this.ruleForm.auditRefuseCheck;
              if(this.ruleForm.auditRefuseCheck == 1){
                e.setValue = 1;
                e.setText = this.ruleForm.auditRefuseCheckInfo;
              } else {
                e.setValue = 0;
              }
            } 
            // 8.初审不通过(可以重新提交)
            if(e.setName == "stationAuditFailCheck"){
              e.setValue = this.ruleForm.stationAuditFailCheck;
              if(this.ruleForm.stationAuditFailCheck == 1){
                e.setValue = 1;
                e.setText = this.ruleForm.stationAuditFailCheckInfo;
              } else {
                e.setValue = 0;
              }
            }         
            // 9.初审不通过(不可以重新提交)
            if(e.setName == "stationAuditRefuseCheck") {
              e.setValue = this.ruleForm.stationAuditRefuseCheck;
              if( this.ruleForm.stationAuditRefuseCheck == 1 ){
                e.setValue = 1;
                e.setText = this.ruleForm.stationAuditRefuseCheckInfo;
              } else {
                e.setValue = 0;
              }
            }
          });
          let configValue = JSON.stringify(this.configValue);
          this.$api.system.setConfigMessageInfo({
            configValue 
          }).then(res=>{
            if(res.code == 1){
              this.$message.success("设置成功");
            }
          })
        } else {
          this.$message.error("请填写完整的表单信息");
          return false;
        }
      });
    },

    /********************************
     * @value : 表单值 (若是不限制短信,设置字段为0,去除错误提示)
     *******************************/
    changeMaxNumber(value){
      if(value){
        this.ruleForm.maxNumber = 0;
        let message = document.querySelector(".isMaxNumber .el-form-item__content .el-form-item__error")
        if(message){
          message.style.display = "none";
        }
      } else {
        let message = document.querySelector(".isMaxNumber .el-form-item__content .el-form-item__error")
        if(message){
          message.style.display = "block";
        }
      }
    },

    /********************************
     * @value : 表单值 (若限制条数,最小值为1)
     *******************************/
    isNumber(rule, value, callback){
      if(!this.ruleForm.isMaxNumber){
        if (/(^[1-9]\d*$)/.test(value)) {
          callback();
        } else {
          callback(new Error('短信条数不可以为0'));
        }
      } else {
        callback();
        return false;
      }
    },

    /********************************
     * @this : 表单输入长度限制
     *******************************/
    // 原版(含有短信签名)
    // auditLangth(rule, value, callback){
    //   this.configValue.forEach(e=>{
    //     if(e.setName == "signName"){
    //       this.signNameLength = e.setText.length;
    //     }
    //   })
    //   this.messageNumber = 68 - this.signNameLength;
    //   if(value.length + this.signNameLength < 68){
    //     callback();
    //   } else {
    //     callback(new Error(`短信内容不能超过${this.messageNumber}字，请调整。`));
    //   }
    // },
    auditLangth(rule, value, callback){
      this.messageNumber = 68;
      if(value.length < 68){
        callback();
      } else {
        callback(new Error(`短信内容不能超过${this.messageNumber}字，请调整。`));
      }
    },
  },
  
};
</script>

<style lang="less" scoped>
.systemBox {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px !important;
  /deep/ .el-form-item__label{
    width: 88px!important;
    color : #737780;
  }

  .el-form-item:not(.is-required){
    padding-left : 60px;
  }
  .el-form-item {
    /deep/ .el-form-item__content{
      padding-bottom: 0px;
      position: relative;
      .el-textarea {
        .el-textarea__inner{
          color : #45494D;         
          transition: 0.5s; 
          width: 100%;
          height: 108px;
        }
        .el-textarea__inner:hover{
          color : #606266;          
        }
      }
    }
  }
  
  .el-form-item.audit-class{
    color : #ccc;
  }

  /* *** 短信条数限制样式 *** */
  .el-form-item.isMaxNumber{
    /deep/ .el-input__inner {
      width:160px;
      padding-left: 0px!important;
    }  
    /deep/ .el-input-number {
      width:160px;
    }
  }

  .el-select.maxNumber {
    width: 90px;
    margin-right: 8px;
    /deep/ .el-input.el-input--suffix {
      width: 100%;
    }
    /deep/ .el-input__inner {
      width: 90px;
    }
  }
  .isMaxNumber {
    display: inline-block;
    /deep/ .el-form-item__content {
      .el-form-item__error{
        display: block;
      }
    }
  }
  .setState {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    span {
      display: block;
      width: 72px;
      color: #737780 ;
      text-align: left;
    }
    .el-input {
      width: 160px;
      height: 36px;
    }
    em {
      position: relative;
      margin-left: -25px;
      z-index: 1;
      font-style: normal;
    }
  }
  .setState {
    align-items: flex-start;
  }
  .setState.audit {
    margin-bottom: 20px;
  }
  .audit{
    margin-bottom: 34px;
  }

  /* 新增 : 表单对应描述 */
  .audit{
    .audit-desc {
      margin-top : 14px;
      color : #9299A6;
    }
  }
  /* 新增 : 选项卡内容 */
  .pane {
    height: 20px;
    margin-bottom: 16px;
    width: 100%;
    .pane-span {
      margin-right: 16px;
      display: inline-block;
      width: auto;
      line-height: 20px;
    }
  }
  /* 新增 : 选项卡样式 */
  .el-tabs.el-tabs--card.el-tabs--top {
    width:100%;
  }
  /* 初审不通过样式 */
  .first-examine {
    border-bottom : 1px dotted #DADDE6;
    width : 60%;
    padding-bottom: 32px;
    margin-bottom: 32px;
    p {
      width: 100%;
    }
  }
  .wordNumber {

    width: auto!important;
    height: 17px;
    position: absolute;
    right: 13px;
    bottom: 23px;
    display: inline!important;
    color : #C2C6CC!important;
  }
  .messageNumber-desc {
    display: inline-block;
    width: 72px;
    color : #737780;
  }
}
</style>